import * as Yup from 'yup';

import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
} from 'react-bootstrap';
import { Field, Formik } from 'formik';

import { Auth } from 'aws-amplify';
import CloseButton from '../Styled/CloseButton';
import ErrorLabel from '../../ui/ErrorLabel';
import cx from 'classnames';
import modalPropTypes from '../../propTypes/modalPropTypes';
import styled from 'styled-components';
import { useState } from 'react';

const Description = styled.p`
  font-size: 16px;
  line-height: 1.5;
  letter-spacing: normal;
  color: #0c1f28;
`;

const EditPasswordModal = ({ show, onHide }) => {
  const schema = Yup.object().shape({
    currentPassword: Yup.string().trim().required('Old password is required'),
    newPassword: Yup.string().trim().required('New password is required.'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
      .required('Confirm password is required'),
  });

  const onSubmit = async values => {
    try {
      const currentUser = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(
        currentUser,
        values.currentPassword,
        values.newPassword,
      );
      addAlert('success', 'Your new password has been set.');
      setTimeout(() => {
        onHide();
      }, 500);
    } catch (error) {
      addAlert('danger', error.message);
    }
  };

  // TODO: make this reusable
  const [showAlert, setShowAlert] = useState(false);
  const [alert, setAlert] = useState(undefined);

  const addAlert = (variant, message) => {
    setShowAlert(true);
    setAlert({ variant, message });
  };

  const hideAlert = () => {
    setShowAlert(false);
    setAlert(undefined);
  };

  return (
    <Modal
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      show={show}
      onHide={onHide}>
      <Modal.Header>
        <CloseButton onClick={onHide} variant={'bordered'} />
      </Modal.Header>
      <Modal.Body className="pt-0 pb-4">
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            currentPassword: '',
            newPassword: '',
            confirmPassword: '',
          }}
          validateOnChange>
          {({ handleSubmit, isValid, isSubmitting }) => (
            <Form onSubmit={handleSubmit}>
              <Container>
                <Row>
                  <Col md={10} className="mb-4">
                    <h2 className="color-dark">
                      Please enter your new password
                    </h2>
                  </Col>
                </Row>
                <Row>
                  <Col className="mb-2">
                    <Description>
                      New password must use at least 8 characters. Include
                      uppercase and lowercase letters. Include at least one
                      number and one symbol. Do not include your name or email.
                    </Description>
                  </Col>
                </Row>
                {showAlert && alert && (
                  <Row>
                    <Col className="mb-2">
                      <Alert
                        variant={alert.variant}
                        onClose={() => hideAlert()}>
                        {alert.message}
                        <CloseButton onClick={() => hideAlert()} />
                      </Alert>
                    </Col>
                  </Row>
                )}
                <Row>
                  <Col className="mb-2">
                    <Field name="currentPassword">
                      {({ field, meta }) => (
                        <Form.Group controlId="currentPassword">
                          <Form.Label>Current password</Form.Label>
                          <Form.Control
                            type="password"
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            isValid={!meta.error && meta.touched}
                            className={cx({ error: !!meta.error })}
                            autoComplete="on"
                          />
                          {meta.error && meta.touched && (
                            <ErrorLabel label={meta.error} />
                          )}
                        </Form.Group>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row>
                  <Col className="mb-2">
                    <Field name="newPassword">
                      {({ field, meta }) => (
                        <Form.Group controlId="newPassword">
                          <Form.Label>New password</Form.Label>
                          <Form.Control
                            type="password"
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            isValid={!meta.error && meta.touched}
                            className={cx({ error: !!meta.error })}
                            autoComplete="off"
                          />
                          {meta.error && meta.touched && (
                            <ErrorLabel label={meta.error} />
                          )}
                        </Form.Group>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row>
                  <Col className="mb-4">
                    <Field name="confirmPassword">
                      {({ field, meta }) => (
                        <Form.Group controlId="confirmPassword">
                          <Form.Label>Confirm password</Form.Label>
                          <Form.Control
                            type="password"
                            value={field.value}
                            onChange={field.onChange}
                            onBlur={field.onBlur}
                            isValid={!meta.error && meta.touched}
                            className={cx({ error: !!meta.error })}
                            autoComplete="off"
                          />
                          {meta.error && meta.touched && (
                            <ErrorLabel label={meta.error} />
                          )}
                        </Form.Group>
                      )}
                    </Field>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col>
                    <Button
                      className="w-100"
                      type="submit"
                      variant="primary"
                      disabled={!isValid && !isSubmitting}>
                      Save
                    </Button>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Button
                      className="w-100"
                      type="button"
                      variant="light"
                      onClick={onHide}>
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </Container>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

EditPasswordModal.propTypes = {
  ...modalPropTypes,
};

export default EditPasswordModal;
